import React, { useState } from 'react';

const ProfilePage = () => {
    // State for profile image, status, and other details
    const [profileImage, setProfileImage] = useState('https://via.placeholder.com/150');
    const [status, setStatus] = useState('Active');
    const [isActive, setIsActive] = useState(true);
    const [name] = useState('John Doe');
    const [email] = useState('johndoe@example.com');
    const [phoneNumber] = useState('+1234567890');
    const [totalMessages] = useState(120);

    // Handle image preview after uploading a new profile image
    const handleImageChange = (event) => {
        const reader = new FileReader();
        reader.onload = () => {
            setProfileImage(reader.result);
        };
        reader.readAsDataURL(event.target.files[0]);
    };

    // Toggle status between Active and Inactive
    const toggleStatus = () => {
        setIsActive(!isActive);
        setStatus(isActive ? 'Inactive' : 'Active');
    };

    // Handle save changes (for now, it will alert the user)
    const handleSaveChanges = () => {
        alert('Profile updated successfully!');
    };

    return (
        <div className="profile-container">
            <h2>Profile Details</h2>
            <div className="table-responsive">
                <table>
                    <thead>
                        <tr>
                            <th>Sr </th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone Number</th>
                            <th>Total Messages</th>
                            <th>Status</th>
                            <th>Change Status</th>
                            <th>Save Changes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>{name}</td>
                            <td>{email}</td>
                            <td>{phoneNumber}</td>
                            <td>{totalMessages}</td>
                            <td id="statusText">{status}</td>
                            <td>
                                <label className="switch">
                                    <input 
                                        type="checkbox" 
                                        checked={isActive} 
                                        onChange={toggleStatus} 
                                    />
                                    <span className="slider"></span>
                                </label>
                            </td>
                            <td>
                                <button className="save-btn" onClick={handleSaveChanges}>
                                    Save
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ProfilePage;
